import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import api from '.';
import { BaseResponseDto } from '../dtos/responses/base.response.dto';
import { GetSchoolsResponseDto } from '../dtos/responses/get-schools.response.dto';

const getSchools = () => {
  return api<BaseResponseDto<GetSchoolsResponseDto[]>, Error>(`/student/school`, {
    method: 'GET',
  });
};

export const useGetSchools = (
  options?: Omit<UseQueryOptions<BaseResponseDto<GetSchoolsResponseDto[]>, Error>, 'queryFn'>,
) => {
  return useQuery({
    queryKey: ['student', 'school'],
    queryFn: () => getSchools(),
    ...options,
  });
};
